import { ReactNode } from "react";
import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { Button, ButtonVariations } from "../../buttons/button";

export const ConfirmDeleteModal = ({
  open,
  handleClose,
  title,
  subtitle,
  onProceed,
  loading,
  children,
  confirmVariation = "danger",
  confirmText = "Delete",
}: ModalCompProps & {
  title: string;
  subtitle: string;
  onProceed: () => void;
  loading: boolean;
  children?: ReactNode;
  confirmVariation?: ButtonVariations;
  confirmText?: string;
}) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className="!max-w-[400px]"
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title={title}
      subtitle={subtitle}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      {children}
      <div className="col-span-full grid w-full grid-cols-2 items-center justify-end gap-2 md:flex">
        <Button
          text="Cancel"
          type="button"
          onClick={() => {
            handleClose();
          }}
          variation="plain-grey"
          className="md:max-w-fit"
        />
        <Button
          text={confirmText}
          type="button"
          onClick={onProceed}
          className="md:max-w-fit"
          loading={loading}
          disabled={loading}
          variation={confirmVariation}
        />
      </div>
    </ModalComponent>
  );
};
